import { type IkeLogStreamType, LOGKEY, LogKeys } from '../../log';
import type { IkeLogType } from '../../log/log.types';
import type { IkeConfig } from '../index';

function register(config: IkeConfig, type: IkeLogType, level: number, stream: IkeLogStreamType, attrs?) {
	config.set(LOGKEY(type, LogKeys.CONSOLE), true);
	config.set(LOGKEY(type, LogKeys.STREAM), stream);
	config.set(LOGKEY(type, LogKeys.LEVEL), level);
	if (attrs != null) {
		config.set(LOGKEY(type, LogKeys.CONFIG), attrs);
	}
}

export const LogConfig = { register };
